

export const CANDIDATE_MODAL_KEYS = {
  NONE: "",
  EDIT: "edit",
  DELETE: "delete",
  PREVIEW: "preview",
};
// =============filter

export const REQUISITION_FILTER_MODAL_KEYS = {
  NONE: "",
  FILTER: "filter",
  EXPORT: "export",
};
export const REQUISTION_MODAL_KEYS={
  NONE:"",
  VIEW:"view",
  DUPLICATE:"duplicate"
}
// ======== view 
export const VIEW_CANDIDATE_MODAL_KEYS={
  NONE: "",
  APPROVE: "approve",
  REJECT: "reject",
  REJECT_SUCCESS:"reject_success",
  APPROVE_SUCCESS: "approve_success",
  ASSIGN:"assign",
  ASSIGN_SUCCESS:"assign_success",
  REQUEST_MODIFICATION: "request_modification",
  MODIFICATION_SUBMITTED_SUCCESS:"modification_submitted_success"


}